import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';
import { ROLES } from './User';
import { getI18nInstance as i18n } from '@/i18n';

export class Role extends BaseModel {
    defaults() {
        return {
            key: null,
        };
    }

    get label() {
        return i18n().t(this.key.toLowerCase());
    }
}

export class RoleCollection extends BaseCollection {
    options() {
        return {
            model: Role,
        };
    }
}

let myRoles: RoleCollection | null = null;

export function getRoles() {
    if (!myRoles) {
        myRoles = new RoleCollection();
        for (const role in ROLES) {
            myRoles.add({ key: ROLES[role] });
        }
    }
    return myRoles;
}
